const getPage = (page) =>
  ({
    "/": "home",
    "/?": "home",
    c: "category-detail",
    p: "product-detail",
    story: "story",
    default: "default",
  }[page ?? "default"]);
// RegEx to find the target in the URL
const regExTarget = /([^/]?women|[^/]?men)|([^/-]?new|[^/]?footwear)/;
// RegEx to find the page in the URL
const regExPage = /([^/]?story|[^/]?p|[^/]?c|^[/]$|^[/][\?])/;

const getTopBannerInfo = (url = "") => {
  const targetResult = url?.match(regExTarget);
  const pageResult = url?.match(regExPage);

  const isValid = ["/", "/?", "c", "p", "story"].some(
    (el) => el === pageResult?.[0].toString()
  );

  let page = getPage(isValid ? pageResult?.[0] : "default");
  let target = "everyone";

  switch (targetResult?.[0]) {
    case "women":
    case "men":
      target = targetResult[0];
      break;
    case "footwear":
    case "new":
      if (page === "story") {
        target = targetResult[0];
      }
      break;
    default:
      break;
  }

  return {
    page,
    target,
  };
};

export { getTopBannerInfo };
